import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

const ChemicalMixSelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { handleAsyncFilter, hasNextPage, isLoading, items, noItemsText, onNextPage } = useData();

    const handleSelected = (mix: Item) => {
        onChange(mix);
        onClose?.(mix);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                hasNextPage={hasNextPage}
                isLoading={isLoading}
                itemSelected={value}
                items={items}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onFilter={handleAsyncFilter}
                onNextPage={onNextPage}
                onSelected={handleSelected}
            />
        </Wrapper>
    );
};

export default ChemicalMixSelectPanelField;
